import { useState, useEffect } from "react";
import { ConfigurationType } from "components/configurations/ConfigurationTypes";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { useStore } from "stores/connect";
import { getConfig } from "components/configurations/helpers";
const FallbackDefaultTokenTTL = "P30D";
const useTokenTTL = (forceDefaultTokenTTL) => {
  const [tokenTtl, setTokenTtl] = useState(forceDefaultTokenTTL || FallbackDefaultTokenTTL);
  const [defaultTokenTtl, setDefaultTokenTtl] = useState(forceDefaultTokenTTL || FallbackDefaultTokenTTL);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  useEffect(() => {
    if (!forceDefaultTokenTTL) {
      ConfigurationsActions.listUserConfig(ConfigurationType.USER_CONFIG).then(() => {
        const config = getConfig(ConfigurationType.USER_CONFIG, configuration);
        if (config == null ? void 0 : config.default_ttl_for_new_tokens) {
          setTokenTtl(config == null ? void 0 : config.default_ttl_for_new_tokens);
          setDefaultTokenTtl(config == null ? void 0 : config.default_ttl_for_new_tokens);
        }
      });
    }
  }, [configuration, forceDefaultTokenTTL]);
  const resetTokenTtl = () => {
    setTokenTtl(defaultTokenTtl);
  };
  return { tokenTtl, defaultTokenTtl, setTokenTtl, resetTokenTtl };
};
export default useTokenTTL;
